export const carmentoList = [
    { name: '김태경', position: '팀장', img: 'carmento1' },
    { name: '허종현', position: '대리', img: 'carmento2' },
    { name: '최진욱', position: '대리', img: 'carmento3' },
    { name: '정의석', position: '과장', img: 'carmento4' },
]

export const partnerList = [
    { name: 'ALPHERA', img: 'ALPHERA' },
    { name: 'CNH 캐피탈', img: 'CNH 캐피탈' },
    { name: 'IM캐피탈', img: 'IM캐피탈' },
    { name: 'JB우리캐피탈', img: 'JB우리캐피탈' },
    { name: 'K car', img: 'K car' },
    { name: 'KDB 캐피탈', img: 'KDB 캐피탈' },
    { name: 'KOLON', img: 'KOLON' },
    { name: 'M 캐피탈', img: 'M 캐피탈' },
    { name: 'NH농협케피탈', img: 'NH농협케피탈' },
    { name: '롯데캐피탈', img: '롯데캐피탈' },
    { name: '메리츠캐피탈', img: '메리츠캐피탈' },
    { name: '미래에셋', img: '미래에셋' },
    { name: '우리금융캐피탈', img: '우리금융캐피탈' },
    { name: '우리카드', img: '우리카드' },
    { name: '플러스 렌터카', img: '플러스 렌터카' },
    { name: '한국캐피탈', img: '한국캐피탈' },
    { name: '현대 캐피탈', img: '현대 캐피탈' },
]